export function dedupeAttendanceItemsById<
  T extends { id?: number | string; service_id?: number; service_name?: string }
>(items: T[] = []) {
  const seen = new Set<string>()
  let duplicateCount = 0

  const uniqueItems = items.filter((item) => {
    const key =
      item.id !== undefined
        ? `id:${item.id}`
        : `service:${item.service_id || ''}:${item.service_name || ''}`

    if (seen.has(key)) {
      duplicateCount += 1
      return false
    }
    seen.add(key)
    return true
  })

  if (duplicateCount > 0 && process.env.NODE_ENV === 'development') {
    console.warn(
      `[financial] Ignored ${duplicateCount} duplicated attendance item(s) from the API response.`
    )
  }

  return uniqueItems
}
